import React from "react";
import Chart from "react-apexcharts";

const CompletionTrendChart = ({data}) => {
//   const data = {
//     success: true,
//     trends: [
//       {
//         date: "2025-04-17",
//         region: [
//           { region: "SE", count: 0 },
//           { region: "NC", count: 0 },
//           { region: "NW", count: 0 },
//           { region: "NE", count: 1 },
//         ],
//       },
//       {
//         date: "2025-04-16",
//         region: [
//           { region: "SE", count: 3 },
//           { region: "NC", count: 5 },
//           { region: "NW", count: 3 },
//           { region: "NE", count: 5 },
//         ],
//       },
//     ],
//   };

  // Get unique regions
  const regions = [...new Set(data.trends.flatMap((t) => t.region.map((r) => r.region)))];

  // Dates for x-axis
  const categories = data.trends.map((t) => t.date);

  // Build series per region
  const series = regions.map((region) => ({
    name: region,
    data: data.trends.map((t) => {
      const found = t.region.find((r) => r.region === region);
      return found ? found.count : 0;
    }),
  }));

  const chartOptions = {
    chart: {
      type: "bar",
      stacked: true,
    },
    xaxis: {
      categories,
    },
    title: {
      text: "Region Trends Over Time",
    },
    yaxis: {
      title: {
        text: "Count",
      },
    },
    legend: {
      position: "top",
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <div>
      <Chart options={chartOptions} series={series} type="bar" height={350} />
    </div>
  );
};

export default CompletionTrendChart;
